import * as React from 'react'
import debounce from 'lodash.debounce'

import { useWindowDomEvent } from './use-dom-event'

const options = { passive: true }

export function useWindowWidth({ debounceMs = 0 }: { debounceMs?: number } = {}) {
  const [windowWidth, setWindowWidth] = React.useState(() =>
    typeof window !== 'undefined' ? window.innerWidth : null,
  )

  const handleResize = React.useCallback(() => {
    setWindowWidth(window.innerWidth)
  }, [])

  const debouncedHandleResize = React.useMemo(
    () => debounce(() => handleResize(), debounceMs),
    [handleResize, debounceMs],
  )

  useWindowDomEvent('resize', debouncedHandleResize, options)

  return windowWidth
}
